import { RootState } from "src/Store/store";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IqueryParams } from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import httpRequest from "src/helpers/httpRequest";
import qs from "qs";
import moment from "moment";
import { toast } from "react-toastify";
import CustomerTableWrapper from "../Customer/CustomerTableWrapper";
import deleteIcon from "src/assets/images/delete-icon.png";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DoctorPrescriptionModal from "../Modals/DoctorPrescriptionModal";
import { capitalize } from "@mui/material";

interface IPrescribedResponse {
  [key: string]: any;
}
interface IPrescribedItem {
  IPrescribedItem?: string;
  [key: string]: any;
}

const AllCustomerPrescription = ({ customerID }: { customerID: string }) => {
  const { allIndicators } = useSelector((store: RootState) => store?.redDots);
  const { userDetails } = useSelector((store: RootState) => store?.appReducer);

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [prescribedData, setPrescribedData] = useState<IPrescribedItem>([]);
  const [openPrescriptionModal, setOpenPrescriptionModal] = useState<{
    id: string;
  } | null>(null);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  }); // Handles pagination state
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
    search: "",
    startDate: "",
    endDate: "",
    customerId: customerID || "",
    doctorId: userDetails?._id || "",
  }); // Query parameters for API request

  // Handles page change in pagination
  const handlePageChange = (e: number) => {
    setQueryParams((prev) => ({
      ...prev,
      page: e,
    }));
  };

  const FetchPrescibedData = async (q: IqueryParams) => {
    setIsLoader(true);

    const { res, err } = await httpRequest<IPrescribedResponse>({
      path: `/appoiment/customer-prescribe-all?${qs.stringify(q)}`,
    });
    if (res) {
      const { documents = [], paginated } = res;
      console.log("Prescription Data ===>", documents);
      setPrescribedData(documents);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const handleChangeQuery = (
    data: Partial<IqueryParams>,
    resetPage: boolean = true
  ) => {
    let newQuery = {
      ...queryParams,
      ...data,
    };
    if (resetPage) {
      newQuery.page = 1;
      setPrescribedData([]);
    }
    setQueryParams(newQuery);
    FetchPrescibedData(newQuery);
  };

  useEffect(() => {
    handleChangeQuery({ page: 1 });
  }, []);
  return (
    <>
      {openPrescriptionModal && (
        <DoctorPrescriptionModal
          id={openPrescriptionModal?.id || ""}
          onClose={() => {
            setOpenPrescriptionModal(null);
          }}
        />
      )}
      <CustomerTableWrapper
        isLoading={isLoader}
        thead={["Customer Name", "Fee", "Time", "Date", "Action"]}
        page={paginated.currentPage || 1}
        total={paginated.totalPages || 0}
        columnWidth={"30% 20% 20% 20% 10%"}
        onChange={handlePageChange}
      >
        {prescribedData?.map((item: any, index: number) => (
          <ul
            key={index}
            className="font-size-16px tbody-light-table customer-table-wrapper-body-padding-non customer-table-wrapper-body tbody-light-table-customer font-Poppins-Regular grid"
            style={{ gridTemplateColumns: "30% 20% 20% 20% 10%" }}
          >
            <li className="!px-7 truncate">
              {capitalize(item?.patientFirstName || "") +
                " " +
                capitalize(item?.patientLastName || "")}
            </li>
            <li>{item?.fees || ""}</li>
            <li>
              {moment(item?.appointmentStartTime, "HH:mm").format("hh:mm A") +
                " - " +
                moment(item?.appointmentEndTime, "HH:mm").format("hh:mm A")}
            </li>
            <li>{moment(item?.prescriptionDate).format("DD-MM-YYYY") || ""}</li>
            <li className="flex items-center gap-2 justify-end">
              <button
                className={`flex items-center !rounded-sm justify-center text-gray-500 cursor-pointer`}
                onClick={() => {
                  setOpenPrescriptionModal({
                    id: item?._id,
                  });
                }}
                id={`view-prescription-${index + 1}`}
              >
                <FontAwesomeIcon
                  icon={faEye}
                  className={`text-theme-color-green font-size-16px`}
                />
              </button>
            </li>
            {/* <li className="action-last-colum">
            <img
            id={`prescribe-delete-btn-${index + 1}`}
            onClick={() => handleDelete(item?._id)}
            src={deleteIcon}
            alt="delete"
            />
          </li> */}
          </ul>
        ))}
      </CustomerTableWrapper>
    </>
  );
};

export default AllCustomerPrescription;
